import { Grid } from '@material-ui/core'
import ChangeLanguageForm from '../../../components/ChangeLanguageForm'
import { MuiClasses } from '../../../types'

interface NavLanguageFormProps {
  smallScreen: boolean
  classes: MuiClasses
}

/** display either mobile or desktop language form */
const NavLanguageForm = ({ smallScreen, classes }: NavLanguageFormProps) =>
  smallScreen ? (
    <ChangeLanguageForm mobile />
  ) : (
    <Grid className={classes.desktopMenu}>
      <ChangeLanguageForm />
    </Grid>
  )

export default NavLanguageForm
